export const icons ={
    logo: require('./logo.jpeg'),
}